/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  request.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:26
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import { AuthHeader } from "@/constant/common";

function getUrl(url: string, params: { [x: string]: any }) {
  return url.replace(/{(\w*)}/g, function (word, $1) {
    return params[$1];
  });
}

function getAuthHeader(token: string) {
  return {
    [AuthHeader]: `Bearer ${token}`,
  };
}

function transformParams(params: { [x: string]: any }) {
  return Object.keys(params)
    .map((i) => `${i}=${encodeURIComponent(params[i])}`)
    .join("&");
}

export { getAuthHeader, getUrl, transformParams };
